export default "__VITE_ASSET__BjUrhAO5__"